import axios from 'axios';
import router from '../../router';

export default {
  state: {
    token: localStorage.getItem('__token') || '',
    user: JSON.parse(localStorage.getItem('user')) || {},
    loading: false,
    status: '',
    companies: [],
    currentCompany: JSON.parse(localStorage.getItem('currentCompany')) || {},
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    isAdmin: (state) => state.user && state.user.role && state.user.role === 'ADMIN',
    isManager: state => state.user && state.user.role && state.user.role === 'MANAGER',
    isUser: state => state.user && state.user.role && state.user.role === 'USER',
    contractNumber: (state) => state.currentCompany.contractNumber
  },
  mutations: {
    LOGIN(state, data) {
      state.user = data;
      state.loading = true;
      axios.post('/api/auth/login', data).then(
        (response) => {
          state.loading = false;
          const token = response.data.token;
          const user = response.data.user;

          localStorage.setItem('__token', token);
          localStorage.setItem('user', JSON.stringify(user));
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          state.user = user;
        },
        (error) => {
          console.log(error);
        }
      );
      state.loading = false;
    },
    REGISTER(data) {
      axios.post('/api/auth/register', data).then(
        (response) => {
          console.log(response);
          router.push('/');
        },
        (error) => console.log(error)
      );
    },
    SET_HEADERS(state) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
    },
    AUTH_REQUEST(state) {
      state.status = 'loading';
    },
    AUTH_SUCCESS(state, { token, user }) {
      state.status = 'success';
      state.token = token;
      state.currentCompany = user;
      state.user = user;
    },
    AUTH_ERROR(state) {
      state.status = 'error';
    },
    AUTH_LOGOUT(state) {
      state.status = '';
      state.token = null;
      state.user = null;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_COMPANIES(state, data) {
      state.companies = data;
      state.companies.push({
        name: state.user.name,
        contractNumber: state.user.contractNumber,
        main: true,
      });
    },
    SET_CURRENT_COMPANY(state, company) {
      state.currentCompany = typeof company === 'string' ? state.companies.find(item => item.contractNumber === company) : company;
      localStorage.setItem('currentCompany', JSON.stringify(state.currentCompany));
    }
  },
  actions: {
    login({ commit }, data) {
      // commit('LOGIN', data);
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit('AUTH_REQUEST');
        axios({ url: '/api/auth/login', data, method: 'POST' })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem('__token', token); // store the token in localstorage
            localStorage.setItem('user', JSON.stringify(user)); // store the token in localstorage
            localStorage.setItem('currentCompany', JSON.stringify(user)); // save current company
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            commit('AUTH_SUCCESS', { token, user });
            resolve(resp);
          })
          .catch((err) => {
            commit('AUTH_ERROR', err);
            localStorage.removeItem('__token'); // if the request fails, remove any possible user token if possible
            localStorage.removeItem('user');
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('AUTH_LOGOUT');
        localStorage.removeItem('__token'); // if the request fails, remove any possible user token if possible
        localStorage.removeItem('user');
        localStorage.removeItem('currentCompany'); // remove current company
        delete axios.defaults.headers.common['Authorization'];
        resolve();
      });
    },
    // eslint-disable-next-line
    register({ }, data) {
      return new Promise((resolve, reject) => {
        axios({ url: '/api/auth/register', data, method: 'POST' })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    forgotPassword({ commit }, data) {
      commit('SET_LOADING', true);
      return new Promise((resolve, reject) => {
        axios({ url: '/api/auth/reset-password', data, method: 'POST' })
          .then((resp) => {
            commit('SET_LOADING', false);
            resolve(resp);
          })
          .catch((err) => {
            commit('SET_LOADING', false);
            reject(err);
          });
      });
    },
    updatePassword({ commit }, data) {
      commit('SET_LOADING', true);
      return new Promise((resolve, reject) => {
        axios({ url: '/api/auth/update-password', data, method: 'POST' })
          .then((resp) => {
            commit('SET_LOADING', false);
            resolve(resp);
          })
          .catch((err) => {
            commit('SET_LOADING', false);
            reject(err);
          });
      });
    },
    addCompany({ commit }, data) {
      commit('SET_LOADING', true);
      return new Promise((resolve, reject) => {
        axios({ url: '/api/user/add-company', data: data, method: 'POST' })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCompanies({ commit }) {
      axios({ url: `/api/user/get-companies`, method: 'GET' })
        .then((resp) => {
          commit('SET_COMPANIES', resp.data);
        });
    },
    setCurrentCompany({ commit }, company) {
      commit('SET_CURRENT_COMPANY', company);
    }
  },
};
